import { render } from "./ContentModal.vue?vue&type=template&id=246b8ef8&scoped=true"
import script from "./ContentModal.vue?vue&type=script&lang=js"
export * from "./ContentModal.vue?vue&type=script&lang=js"

import "./ContentModal.vue?vue&type=style&index=0&id=246b8ef8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-246b8ef8"]])

export default __exports__